import { Component, AfterViewInit, ChangeDetectorRef,  ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-front-page',
  templateUrl: './front-page.component.html',
  styleUrls: ['./front-page.component.scss']
})

export class FrontPageComponent implements AfterViewInit {
  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService,  private cdr: ChangeDetectorRef) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/page/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [
          {label: 'No', type: 'index'}, 
          {label: 'Title', type: 'string', key: 'title'}, 
          {label: 'Identifier', type: 'string', key: 'page_identifier'}, 
          {label: 'Language', type: 'string', key: 'language'}, 
          {label: 'Status', type: 'status', key: 'status'}, 
          {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/front/page/form', hide: true},
          {label: 'Delete', type: 'delete', key: 'uuid', table: 'page', title: 'title', hide: true},
        ]}
    this.tb.init(setting);
//    this.cdr.detectChanges();
  }
}
